/** Created by azhou on 2019/3/14.*/
<template>
    <div>
      <public-title>{{modes==0?'添加':'修改'}}银行卡
        <span class="text-link ml-auto h6" slot="right" @click="$router.back()">返回列表</span>
      </public-title>
      <div class="load-area">
        <div class="mb-3 w-70 m-auto d-center-start" >
          <left-text leftText="所属类型" required/>
          <el-radio-group v-model="bankcardInfo.type">
            <el-radio class="mr-4" :label="item.id" v-for="item in $GVAR.bankType" :key="item.name">{{item.name}}</el-radio>
          </el-radio-group>
        </div>
        <left-text-border class="mb-3 w-70 m-auto" :leftText="bankcardInfo.type==1?'企业名称':'个人姓名'" v-model="bankcardInfo.truename" required/>
        <div class="d-center-start mb-3 w-70 m-auto">
          <left-text leftText="开户银行" required/>
          <el-select v-model="bankcardInfo.bank_name" filterable placeholder="请选择开户银行" class="w-100" v-show="!showInputBank"   allow-create>
            <el-option v-for="item in $GVAR.bankList" :key="item.text" :label="item.text" :value="item.text" />
          </el-select>
          <!-- <el-input v-show="showInputBank" placeholder="请输入开户银行" v-model="bankcardInfo.bank_name"/> -->
        </div>
        <!-- <div class="d-center-start mb-2 w-70 m-auto">
          <left-text /><span class="text-link h6" @click="showInputBank = !showInputBank">银行不在列表内？点击自己添加银行单位名</span>
        </div> -->
        <left-text-border class="mb-4 w-70 m-auto" leftText="银行卡号" v-model="bankcardInfo.bank_card" required type="Number"/>
        <div class="d-center-start mb-2 w-70 m-auto">
          <select-city class="w-100" :thirdMode="false" leftText="开户行所在地" required @getCityInfo="getCityInfo" :provinceId="bankcardInfo.province" :cityId="bankcardInfo.city"/>
          <!-- <el-input placeholder="详细支行名称" class="ml-1" v-model="bankcardInfo.branch"/> -->
        </div>
        <left-text-border class="mb-4 w-70 m-auto" leftText="开户支行名称" v-model="bankcardInfo.branch" required/>
        <left-text-border class="mb-4 w-70 m-auto" leftText="备注" v-model="bankcardInfo.remark"/>
        <div class="mb-3 w-70 m-auto d-start-start" v-if="bankcardInfo.type==2">
          <left-text leftText="企业委托证明" required/>
          <upload-image @fileChange="(imgs)=>RoomObj = imgs"
                        :existImgs="RoomObj" :maxLength="1" editMode/>
        </div>
        <!-- <div class="d-center-start mb-4 w-70 m-auto">
          <left-text leftText="手机号"/>
          <div>{{userLoginMessage.mobile | formatPhone}}</div>
        </div>
        <div class="d-center-start mb-4 w-70 m-auto">
            <left-text leftText="验证码" required/>
            <send-phone-code :phoneNumber="userLoginMessage.mobile" template="SMS_269200254" class="w-20" url="/pc/User/GetSafeCode"
                            @showError="msg => this._alert(msg,null,'error')"
                            @getCode="code => this.bankcardInfo.sms_code = code"/>
        </div> -->
        <el-button type="primary" @click="addBankcard">提交</el-button>
        <p class="mt-2 text-muted h6">
          <i class="iconfont icon-xuzhixianxiao h6 mr-1 text-danger"></i>
          如果添加多张银行卡，平台只会打款到结算卡中
        </p>
      </div>
    </div>
</template>
<script>
  import { UploadImages } from '@/assets/utils/uploadFiles'
  import { mapGetters,mapMutations, mapActions,mapState} from 'vuex'
  export default {
    name: 'addBankcard',
    data() {
      return {
        RoomObj:[],
        bankcardInfo:{
          type:'1',                         //所属类型
          truename:'',                      //开户人姓名
          bank_name:'',                     //开户银行
          bank_card:'',                     //银行卡号
          branch:'',                        //开户支行名称
          remark:'',                        //备注
          pic:'',                           //个人授权证明
          sms_code:'',                      //验证码
          province:'',                      //省
          city:'',                          //市
        },
        showInputBank:false,
      }
    },
    computed: {
      ...mapState(['userHeadInfo','userLoginMessage']),
      ...mapGetters(['storeInfo']),
      storeId() { return this.$route.query.store },
      //0添加银行卡-1修改银行卡
      modes() { return this.$route.query.modes }
    },
    mounted() {
      this.UPDATECURRENTSTORE({storeId:this.storeId})
      if(this.modes==1){
        this.Details(this.$route.query.id)
      }
    },
    destroyed() {
      this.UPDATECURRENTSTORE({storeId:''})
    },
    methods:{
      ...mapMutations(['UPDATECURRENTSTORE']),
      ...mapActions(['addStoreBankcard','getStoreBankcardDetails']),
      getCityInfo(info){
        this.bankcardInfo.province = info.province;
        this.bankcardInfo.city = info.city;
      },
      /*修改获取详情*/
      Details(id){
        console.log(id);
        this.getStoreBankcardDetails({
          id:id,
          successFun: (e) => {
            this.bankcardInfo={
              ...e,
              type:e.type==1?'1':'2',
            }
            if(e.type==2){
              this.RoomObj.push(e.pic);
            }
            // console.log(e);
          }
        });
      },
      /*表单验证*/
      validateForm () {
          let mayFormdata=this.bankcardInfo;
          if (!mayFormdata.truename) return { code: false, msg: '请填写企业名称或个人姓名' }
          if (!mayFormdata.bank_name) return { code: false, msg: '请填选择或填写开户银行' }
          if (!mayFormdata.bank_card) return { code: false, msg: '请填写银行卡号' }
          if (!mayFormdata.province&&!mayFormdata.city) return { code: false, msg: '请选择开户行所在地' }
          if (!mayFormdata.branch) return { code: false, msg: '请填写开户支行名称' }
          if (!this.RoomObj&&this.bankcardInfo.type==2) return { code: false, msg: '请上传个人授权证明' }
          // if (!mayFormdata.sms_code) return { code: false, msg: '请填写手机验证码' }
          return { code: true, msg: '表单验证通过' }
      },
       /*提交表单*/
        addBankcard() {
        let result = this.validateForm();
        if (result.code) {
          this._confirm('确定添加银行卡么？',async() => {
            //上传图片
            if(this.bankcardInfo.type==2){
              this.bankcardInfo.pic = await UploadImages(this.RoomObj);
              this.bankcardInfo.pic = this.bankcardInfo.pic.join(',');
            }
            this.addStoreBankcard({data:this.bankcardInfo,modes:this.modes});
          })
        }else this._alert(result.msg,null,'error');
      }
    }
  }
</script>
<style scoped lang="scss">
  .w-50{
    min-width: 500px;
  }
</style>
